import { AddToBagVerificationFlags } from '../types'

export const getAddToBagVerificationFlags = (): AddToBagVerificationFlags => ({
  shouldShowProductDetails:
    process.env.IS_ADD_TO_BAG_VERIFICATION_PRODUCT_DETAILS_ENABLED === 'enabled',
  shouldShowGoToCartBtn:
    process.env.IS_ADD_TO_BAG_VERIFICATION_GO_TO_CART_BUTTON_ENABLED === 'enabled',
  shouldShowCloseIcon: process.env.IS_ADD_TO_BAG_VERIFICATION_CLOSE_ICON_ENABLED === 'enabled',
  shouldShowShoppingBagCounter:
    process.env.IS_ADD_TO_BAG_VERIFICATION_SHOPPING_BAG_COUNTER_ENABLED === 'enabled',
  hasBorder: process.env.IS_ADD_TO_BAG_VERIFICATION_BORDER_ENABLED === 'enabled',
  hasFullBorder: process.env.IS_ADD_TO_BAG_VERIFICATION_FULL_BORDER_ENABLED === 'enabled',
})
